/* =========================

  diagnoise contents

============================ */
// import styled from "styled-components";
import { Helmet } from "react-helmet";
import { useEffect } from "react";

// import {break_point_sp} from "../../Styled/mixin";
import Header from "../../Components/Header/index";
import Diagnoise from "./part/Diagnoise";


/* -------------------------

  component

---------------------------- */
function App() {
  useEffect(() => {
    document.querySelector("#footer_contents").style.display="none";
  }, []);

  return (
    <>
    <Helmet>
      <title>お悩み別アイテム診断 | 【公式】健康家族 通販サイト</title>
      <meta name="description" content="健康家族の1分でできるお悩み別アイテム診断です。5つの簡単な質問に答えるだけ！お悩みに合わせてあなたにピッタリの商品をご案内します。" />
      <meta name="keywords" content="悩み,商品,無料,診断,健康家族" />
      <meta name="viewport" content="width=device-width,initial-scale=1.0,minimum-scale=1.0"></meta>
    </Helmet>

    <Header/>

    {/* start,diagnoise,pagenation,reset,finish */}
    <Diagnoise></Diagnoise>

    </>
  );
}

export default App;

/* -------------------------

  styled

---------------------------- */
// const Styled = styled.div`
// 	@media ${break_point_sp} {
// 	}
// `;
